import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import theme from './MediaView.scss';

class MediaView extends PureComponent {
  static propTypes = {
    src: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    comment: PropTypes.string.isRequired,
    zoom: PropTypes.number,
    rotation: PropTypes.number,
    isExpanded: PropTypes.bool,
    onImageDrag: PropTypes.func.isRequired,
    imageWasDragged: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    zoom: 1,
    rotation: 0,
    isExpanded: false,
  };

  static getDerivedStateFromProps(props) {
    return !props.imageWasDragged
      ? {
        top: 0,
        left: 0,
        rel: null,
      }
      : null;
  }

  state = {
    dragging: false,
    top: 0,
    left: 0,
    rel: null,
  };

  componentDidUpdate(props, state) {
    if (this.state.dragging && !state.dragging) {
      document.addEventListener('mousemove', this.onMouseMoveHandle);
      document.addEventListener('mouseup', this.onMouseUpHandle);
    } else if (!this.state.dragging && state.dragging) {
      document.removeEventListener('mousemove', this.onMouseMoveHandle);
      document.removeEventListener('mouseup', this.onMouseUpHandle);
    }
  }

  onMouseDownHandle = (e) => {
    if (e.button !== 0) {
      return false;
    }

    const { top, left } = this.state;

    this.setState({
      dragging: true,
      rel: {
        top: e.pageY - top,
        left: e.pageX - left,
      },
    });


    this.props.onImageDrag();

    e.stopPropagation();
    e.preventDefault();
  };

  onMouseUpHandle = (e) => {
    this.setState({
      dragging: false,
    });

    e.stopPropagation();
    e.preventDefault();
  };

  onMouseMoveHandle = (e) => {
    if (!this.state.dragging) {
      return false;
    }

    this.setState({
      top: e.pageY - this.state.rel.top,
      left: e.pageX - this.state.rel.left,
    });

    e.stopPropagation();
    e.preventDefault();
  };

  getComputedStyles = () => {
    const { zoom, rotation } = this.props;
    const { left, top } = this.state;
    return ({
      transform: `rotate(${ rotation }deg) scale(${ zoom })`,
      left: `${ left }px`,
      top: `${ top }px`,
    });
  };

  render() {
    const { src, name, comment, isExpanded } = this.props;
    const styles = this.getComputedStyles();

    return (
      <div className={ theme.root }>
        <a
          tabIndex="-1"
          className={ classnames({
            [theme.fullscreen]: isExpanded,
          }) }
          href={ src }
          download={ name }
          onClick={ (e) => e.preventDefault() }
          draggable={ true }
          onMouseDown={ this.onMouseDownHandle }
          style={ styles }
        >
          <img
            alt={ comment }
            src={ src }
          />
        </a>
      </div>
    );
  }
}

export default MediaView;
